import { customerReviewRoute } from './customer-review';

export const allCustomerReview = [
  customerReviewRoute(),
];
